import React from "react";
import Input from "@components/forms/Input";

const VerificationForm = ({ t, verificationCode, setVerificationCode, handleVerifyCode, handleLoginAttempt, loading }) => {
  return (
    <>
      <div className="mb-4">
        <Input
          value={verificationCode}
          handleChange={(e) => setVerificationCode(e.target.value)}
          placeholder={t("verification_code")}
          type="text"
        />
      </div>

      <div className="d-flex flex-row mb-3">
        <button
          type="button"
          className="rounded p-3 btn-blue me-2"
          onClick={handleVerifyCode}
          disabled={!verificationCode || loading}
          style={{width:"120px"}}
        >
          {loading ? t("loading") : t("verify")}
        </button>
        <button
          type="button"
          className="btn text-blue border-blue"
          onClick={() => handleLoginAttempt(true)}
          disabled={loading}
          style={{width:"120px"}}
        >
          {t("send_again")}
        </button>
      </div>

      <div className="d-grid">
        
      </div>
    </>
  );
};

export default VerificationForm;
